import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { API_URL } from '../config';

const Desh = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [countries, setCountries] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState(null);

  useEffect(() => {
    // Scroll to top when the component mounts or when a route changes
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`${API_URL}api/country/fatchCountrynews`);
        if (response.data.status === 'success') {
          setData(response.data.data || []);
          const uniqueCountries = [...new Set(response.data.data.map(item => item.CountryName))];
          setCountries(uniqueCountries);
        }
      } catch (err) {
        console.error(err);
        setError('No Updates available at this moment.');
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const filteredData = selectedCountry
    ? data.filter(item => item.CountryName === selectedCountry)
    : data;

  const renderMedia = (item) => {
    if (item.link) {
      return (
        <iframe
          src={item.link}
          title={item.CountryName}
          className="img-fluid w-100"
          style={{ objectFit: 'cover', height: '200px' }}
        />
      );
    } else if (item.image) {
      const imageUrl = `${API_URL}${item.image}`;
      return (
        <img
          src={imageUrl}
          alt={item.CountryName}
          className="img-fluid w-100"
          style={{ objectFit: 'cover', height: '200px' }}
        />
      );
    } else {
      return (
        <div
          className="img-fluid w-100 bg-secondary d-flex justify-content-center align-items-center"
          style={{ height: '200px' }}
        >
          No media available
        </div>
      );
    }
  };

  const renderLoading = () => {
    return (
      <div className="text-center">
        <p>Loading...</p>
      </div>
    );
  };

  if (loading) return renderLoading();

  if (error) return (
    <div>
      <p style={{ color: 'red' }}>{error}</p>
      <button onClick={() => window.location.reload()}>Retry</button>
    </div>
  );

  return (
    <div className="container-fluid mt-5 pt-3" style={{ backgroundColor: 'white' }}>
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            {/* Country Selection Section */}
            <div className="col-12 mb-4">
              <div className="section-title" style={{
                color: 'white',
                backgroundColor: '#002147',
                marginBottom: '20px',
                padding: '10px'
              }}>
                <h4 className="section-title">
                  <span style={{ color: 'white' }}>देश चुनें</span>
                </h4>
              </div>
              <div className="d-flex flex-wrap gap-2 p-3 border">
                {countries.map((country) => (
                  <button
                    key={country}
                    onClick={() => setSelectedCountry(country)}
                    className={`btn ${selectedCountry === country ? 'btn-primary' : 'btn-outline-primary'} me-2 mb-2`}
                  >
                    {country}
                  </button>
                ))}
                {selectedCountry && (
                  <button
                    onClick={() => setSelectedCountry(null)}
                    className="btn btn-outline-secondary me-2 mb-2"
                  >
                    सभी देश
                  </button>
                )}
              </div>
            </div>

            <div className="row">
              <div className="col-12">
                <div
                  className="section-title"
                  style={{
                    color: 'white',
                    backgroundColor: '#002147',
                    marginBottom: '20px',
                    padding: '10px'
                  }}
                >
                  <h4 className="section-title">
                    <span style={{ color: 'white' }}>
                      {selectedCountry ? `${selectedCountry} की खबरें` : 'देश'}
                    </span>
                  </h4>
                </div>
              </div>

              {filteredData.map((item) => (
                <div className="col-lg-4 col-md-6 mb-4" key={item.id}>
                  <div className="position-relative mb-3" style={{ height: '450px' }}>
                    {renderMedia(item)}
                    <div className="allcolor border border-top-0 p-4" style={{ height: '250px', overflow: 'hidden' }}>
                      <div className="mb-2">
                        <span className="badge bg-primary">{item.CountryName}</span>
                        <small className="ms-2 text-muted">
                          {new Date(item.created_at).toLocaleDateString('hi-IN')}
                        </small>
                      </div>

                      <Link
                        to={`/countrynews/${item.id}`}
                        className="alla h2 d-block mb-3 text-uppercase font-weight-bold"
                        onClick={() => {
                          window.scrollTo({ top: 0, behavior: 'smooth' });
                        }}
                      >
                        {item.short_description}
                      </Link>

                      <p className="allp m-0" style={{ overflow: 'hidden', textOverflow: 'ellipsis', display: '-webkit-box', WebkitLineClamp: 3, WebkitBoxOrient: 'vertical' }}>
                        {item.description || 'No description available'}
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Desh;
